import UploadAvatarOnboarding from './UploadAvatarOnboarding';

export default UploadAvatarOnboarding;
